import React from 'react'
import { 
  array,
  object,
  number,
  string,
} from 'yup'

import resourceInfo from 'shared/src/resource/info'

import icons from 'settings/icons'

import ResourceFinder from 'pages/resource/Finder'
import IconTitle from 'components/resource/IconTitle'
import PriceSummary from 'components/resource/PriceSummary'
import TemplateTimeSummary from 'components/resource/TemplateTimeSummary'
import LinkInfo from 'components/resource/LinkInfo'

const EditIcon = icons.edit
const TotalIcon = icons.total

const template = (project) => {
  return [[{
    id: 'meta.baseline',
    title: 'Baseline',
    default: 1,
    inputProps: {
      type: 'number',
    },
    helperText: 'What is the baseline used for calculations?',
    validate: {
      type: 'number',
      methods: [
        ['required', 'Required'],
      ],
    },
  },{
    id: 'meta.unit',
    title: 'Unit',
    default: '',
    component: 'unitselect',
    unitType: 'all',
    customUnits: project.meta.units || [],
    helperText: 'What unit is the template measured in?',
    validate: {
      type: 'string',
      methods: [
        ['required', 'Required'],
      ],
    },
  }],{
    id: 'links',
    title: `Resources`,
    helperText: 'Add resources',
    list: {
      mainField: 'resource.name',
      itemActionHandlers: {
        edit: (link, storeActions) => {
          const resource = link.resource
          storeActions.navigateTo('resource.edit', {
            section: resource.section,
            parentid: resource.parent || 'root',
            type: resource.type,
            id: resource.id,
          })
        }
      },
      table: [{
        name: 'name',
        title: 'Resource',
        sortable: true,
        render: (link) => {
          return (
            <div>
              <IconTitle
                type={ link.resource.type }
                title={ link.resource.name }
              />
              <LinkInfo
                currency={ project.meta.currency.symbol }
                resource={ link.resource }
              />
            </div>
          )
        }
      }, {
        name: 'amount',
        title: 'Amount',
        width: '15%',
        numeric: true,
        editor: (link, formValues) => {
          const resourceMode = resourceInfo.getTemplateResourceMode(link.resource, formValues.meta.unit)
          if(resourceMode != 'amount') return null
          return {
            id: 'meta.amount',
            noTitle: true,
            default: 0,
            inputProps: {
              type: 'number',
              className: 'inputRightAlign',
            }
          }
        },
        render: (link, formValues) => {
          return (
            <TemplateTimeSummary
              template={ formValues }
              link={ link }
            />
          )
        }
      }, {
        name: 'unit',
        title: 'Unit',
        width: '15%',
        numeric: true,
        render: (link, formValues) => {
          const resourceMode = resourceInfo.getTemplateResourceMode(link.resource, formValues.meta.unit)
          const meta = link.resource.meta || {}
          return resourceMode == 'price' ? (
            <div>{ formValues.meta.baseline } { formValues.meta.unit }</div>
          ) : meta.unit || link.resource.type == 'labour' ? 'day' : ''
        },
      }, {
        name: 'price',
        title: 'Price',
        width: '15%',
        numeric: true,
        editor: (link, formValues) => {
          const resourceMode = resourceInfo.getTemplateResourceMode(link.resource, formValues.meta.unit)
          if(resourceMode != 'price') return null
          return {
            id: 'meta.price',
            noTitle: true,
            default: 0,
            inputProps: {
              type: 'number',
              className: 'inputRightAlign',
            },
          }
        },
        render: (link, formValues) => {
          return (
            <PriceSummary
              currency={ project.meta.currency.symbol }
              resource={ link.resource }
              amount={ link.meta.amount }
              noUnit
              noAnnotation
            />
          )
        }
      }, {
        name: 'info',
        title: 'Info',
        numeric: true,
        width: '15%',
        render: (link) => {
          return resourceInfo.isTimeBased(link.resource) ? (
            <PriceSummary
              currency={ project.meta.currency.symbol }
              resource={ link.resource }
              amount={ 1 }
              unit={ 'day' }
              noPrice
            />
          ) : (
            <PriceSummary
              currency={ project.meta.currency.symbol }
              resource={ link.resource }
              amount={ link.meta.amount }
              noPrice
            />
          )
        },
      }],
      getExtraData: ({
        data,
        formValues,
      }) => {
        const meta = formValues.meta || {}
        return [{
          id: 'total',
          hideDelete: true,
          hideEdit: true,
          name: (
            <IconTitle
              bold
              UseIcon={ TotalIcon }
              title="Total"
            />
          ),
          unit: (
            <div
              style={{
                fontWeight: 'bold',
              }}
            >
              { meta.baseline || 0 } { meta.unit || '' }
            </div>
          ),
          price: (
            <PriceSummary
              currency={ project.meta.currency.symbol }
              resource={{
                type: 'template',
                meta,
                links: data,
              }}
              amount={ meta.baseline || 0 }
              unit={ 'day' }
              bold
              noUnit
            />
          ),
        }]
      },
      getDialog: ({
        open,
        onCancel,
        onSave,
      }) => (
        <ResourceFinder
          open={ open }
          title="Add"
          excludeFilter={ ['template'] }
          onCancel={ onCancel }
          onSave={ (resource) => {
            onSave({
              resource,
              meta: {
                amount: 1,
                price: 0,
              }
            })
          } }
        />
      )
    }
  }]
}

export default template